
'use client'

import HeaderSection from 'styleguide/sections/Header';
import useCart from '@/hooks/cart-hook';
import { useEventTracker } from '@/lib/analytic-events';
import useUser from '@/hooks/user-hook';
import { useCookie } from 'react-use';
import { useEffect, useState } from 'react';
import { getGlobalContent } from '@/lib/strapi';
import { checkintPoints, getFeaturedImgMeta } from '@/lib/utils';
import { getCookie } from '~/modules/utils';
import { growthbook } from "@/lib/growthbook";


const Header = (props: any	) => {
	const { disabledScroll, mainNav, annBar, envStore } = props;

	const { toggleCart, cart, flashBubble, setFlashBubble, openDropdownRegister, setOpenDropDownRegister } = useCart();
	const { trackEvent } = useEventTracker();

	const { points, setPoints, originalPts, isAuthenticated } = useUser();
	const [store] = useCookie('region');
	const [data, setdata] = useState({...props, annBar: {...annBar, loaded: false}});

	const updateContentOnRegionChange = async (region: string) => {
        // console.log('store', region);
		const globalData = await getGlobalContent({ preview: region === 'dev' ? 'staging' : '', store: region });

		if (region === 'us' && globalData) {
			setdata({...data, annBar: { ...globalData.annBar, loaded: true}});
			return;
		}
		setdata({ ...globalData, annBar: { ...globalData.annBar, loaded: true} })
    }

    useEffect(() => {
        if (store !== null) updateContentOnRegionChange(store);
		else if (store === null) {
			const region = getCookie('region') !== null ? getCookie('region') : envStore;
			updateContentOnRegionChange(region);
		}
    }, []);

	return (
		<>
			{data && (
				<HeaderSection
					annBar={data.annBar}
					timerBar={data.timerBar}
					generalSetting={data.generalSetting}
					mainMenu={data.mainNav}
					aboutMenu={data.aboutMenu}
					shopMenu={data.shopMenu}
					helpMenu={data.helpMenu}
					menuBannerQuiz={data.menuBannerQuiz}
					menuBannerCode={data.menuBannerCode}
					searchBox={data.searchBox}
					cartCount={cart.itemCount}
					checkoutUrl={cart.checkoutUrl}
					onToggleCart={toggleCart}
					flashBubble={flashBubble}
					setFlashBubble={setFlashBubble}
					trackEvent={trackEvent}
					points={points}
					setPoints={setPoints}
					cart={cart}
					cartItems={cart.items}
					originalPts={originalPts}
					disabledScroll={disabledScroll}
					isAuthenticated={isAuthenticated}
					openDropdownRegister={openDropdownRegister}
					setOpenDropDownRegister={setOpenDropDownRegister}
					swellLoyalty={data.swellLoyalty}
					store={store}
					getFeaturedImgMeta={getFeaturedImgMeta}
					checkintPoints={checkintPoints}
					addingReward={props.addingReward || false}
					setAccountPage={props.setAccountPage || false}
					accountPageKey={props.accountPageKey || null}
				/>
			)}
		</>
	);
}

export default Header;
